import React from "react";
import { IconEdit, IconDuplicate, IconDelete, iconBtnStyle, RowActionIcons } from "../shared/icons/IconLib";

/**
 * Platform Asset list card (accent bar, title, category, address, notes, actions).
 * Used on Asset Management and peek overlays (e.g. Insurance → Asset).
 */
export default function AssetEntityCard({
  asset,
  selected = false,
  onSelectChange,
  showCheckbox = true,
  onTitleClick,
  onEdit,
  onDuplicate,
  onDelete,
  showActions = true,
}) {
  const a = asset || {};
  const title = a.name || "—";

  return (
    <div className="card">
      <div className="card-header">
        {showCheckbox ? (
          <input
            type="checkbox"
            checked={!!selected}
            onChange={(e) => onSelectChange && onSelectChange(e.target.checked)}
          />
        ) : null}
        <div className="card-header-content">
          {onTitleClick ? (
            <button type="button" className="btn-link card-title" onClick={onTitleClick}>
              {title}
            </button>
          ) : (
            <div className="btn-link card-title" style={{ cursor: "default", textDecoration: "none" }}>
              {title}
            </div>
          )}
          {a.category ? <div className="panel-hint">{a.category}</div> : null}
        </div>
      </div>
      {a.address ? <div className="panel-hint card-notes">{a.address}</div> : null}
      {a.notes ? (
        <div className="panel-hint card-notes">{a.notes}</div>
      ) : (
        <div className="panel-hint card-notes">—</div>
      )}
      {showActions ? (
        <div className="card-footer">
          <RowActionIcons variant="inline">
            {onEdit ? (
              <button type="button" onClick={onEdit} className="btn-link" style={iconBtnStyle} title="Edit">
                <IconEdit size={18} />
              </button>
            ) : null}
            {onDuplicate ? (
              <button type="button" onClick={onDuplicate} className="btn-link" style={iconBtnStyle} title="Duplicate">
                <IconDuplicate size={18} />
              </button>
            ) : null}
            {onDelete ? (
              <button type="button" onClick={onDelete} className="btn-link-danger" style={iconBtnStyle} title="Delete">
                <IconDelete size={18} />
              </button>
            ) : null}
          </RowActionIcons>
        </div>
      ) : null}
    </div>
  );
}
